import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51291600"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewport flex" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_4 = { class: "introduce" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }

import { StyleValue } from 'vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['bgColor', 'logo', 'title', 'advantage', 'mfcolor'],
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ '--bkColor': __props.bgColor, '--mfcolor': __props.mfcolor }),
    class: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "logo",
        src: __props.logo,
        alt: ""
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.advantage, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: i
            }, [
              _createVNode(SvgIcon, { name: "market_icon_check" }),
              _createElementVNode("span", _hoisted_7, _toDisplayString(item), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 4))
}
}

})